<template>
  <div>
    <!-- Código de contabilidad -->
    <div class="section-card row pt-2 mb-4">
      <div class="col col-sm-4 col-lg-3">
        <input type="text" v-model.trim="codigoLocal" class="form-control"
          placeholder="codigo contabilidad..." style="height:1.9em" />
        <label><small><span class="text-danger">*</span> Código de contabilidad</small></label>
      </div>
      <div class="col">
        <v-btn small :disabled="onlyReadConta" color="primary" tile @click="$emit('guardar-codigo', codigoLocal)">
          Guardar código de contabilidad
        </v-btn>
      </div>
      <div v-if="mostrarNetsuite" class="col">
        <v-btn small :disabled="onlyReadConta || yaenvidoLoading" color="orange" dark tile
          @click="$emit('abrir-netsuite')" :loading="yaenvidoLoading">
          Agregar a Netsuite
        </v-btn>
      </div>
    </div>

    <!-- Sucursal para factura -->
    <div class="section-card">
      <v-form ref="vform" v-model="formValid" lazy-validation>
        <div v-if="matriz">{{ matriz.direccion }} {{ matriz.ciudad }}</div>
        <v-row>
          <v-col cols="8">
            <v-select :rules="fieldRules" v-model="sucursalLocal" :items="sucursales" :disabled="onlyReadConta"
              item-text="text_nit" outlined dense label="Sucursal de Programa para la factura"
              return-object messages="Para emisión de recibo y factura debe seleccionar la sucursal." />
          </v-col>
          <v-col cols="4">
            <v-btn color="primary" :disabled="onlyReadConta" tile @click="$emit('guardar-sucursal')">
              Guardar / Asignar Sucursal
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SeccionContabilidad',
  props: {
    codigoContabilidad: { type: String, default: '' },
    sucursal: { default: null },
    sucursales: { type: Array, default: () => [] },
    matriz: { default: null },
    onlyReadConta: { type: Boolean, default: false },
    mostrarNetsuite: { type: Boolean, default: false },
    yaenvidoLoading: { type: Boolean, default: false },
  },
  data() {
    return {
      codigoLocal: this.codigoContabilidad,
      sucursalLocal: this.sucursal,
      formValid: true,
      fieldRules: [(v) => !!v || 'Campo Obligatorio'],
    };
  },
  watch: {
    codigoContabilidad(val) { this.codigoLocal = val; },
    sucursal(val) { this.sucursalLocal = val; },
    sucursalLocal(val) { this.$emit('update:sucursal', val); },
    codigoLocal(val) { this.$emit('update:codigoContabilidad', val); },
  },
};
</script>

<style scoped>
.section-card { background:#fff; border:1px solid #e6e9f0; border-radius:12px; padding:14px 14px 6px; margin-top:16px; box-shadow:0 4px 12px rgba(0,0,0,.04); }
</style>
